var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-dependency-injection";
import { BrandingPreviewBase } from "../../branding/branding-preview-base";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { StepEnum } from "../../../../../models/modules/lotteryplatofrm.models";
import { LotteryBrandingText } from "./branding-steps/lottery-branding-text";
import { LotteryBrandingColors } from "./branding-steps/lottery-branding-colors";
import { EventAggregator } from "aurelia-event-aggregator";
import { LotteryBrandingImages } from "./branding-steps/lottery-branding-images";
import { I18N } from "aurelia-i18n";
import { LookupClientService } from "../../../../../services/lookups/lookup-client.service";
import { TokenClient } from "../../../../../services/authentication/token-client.service";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { BrandClientService, LotteryKeyHelper, TemplateType } from "../../../../../services/modules/brand-client.service";
import { AttachmentClientService } from "../../../../../services/modules/attachements-client.service";
import { LotteryBrandingAssets } from './branding-steps/lottery-branding-assets';
import { CacheClient } from "../../../../../services/basics/client-caching.service";
import { LotteryBrandingAssetColors } from "./branding-steps/lottery-branding-asset-colors";
import { LotteryBrandingAssetsText } from "./branding-steps/lottery-branding-assets-text";
import { LotteryBrandingAds } from "./branding-steps/lottery-branding-ads";
import { JsonLockClientService } from "../../../../../services/modules/json-lock-client-service";
var LotteryBrandingDialog = /** @class */ (function (_super) {
    __extends(LotteryBrandingDialog, _super);
    function LotteryBrandingDialog(element, notificationService, i18N, eventAggregator, lookupClientService, cacheClient, lotteryBrandingText, lotteryBrandingImages, lotteryBrandingAssets, lotteryBrandingColors, lotteryBrandingAssetColors, lotteryBrandingAds, tokenClientService, dialogClientService, brandClientService, attachmentClientService, lotteryBrandingAssetText, jsonLockClientService) {
        var _this = _super.call(this, element, notificationService, i18N, eventAggregator, tokenClientService, lookupClientService, dialogClientService, brandClientService, attachmentClientService, cacheClient, jsonLockClientService) || this;
        _this.lotteryBrandingText = lotteryBrandingText;
        _this.lotteryBrandingImages = lotteryBrandingImages;
        _this.lotteryBrandingAssets = lotteryBrandingAssets;
        _this.lotteryBrandingColors = lotteryBrandingColors;
        _this.lotteryBrandingAssetColors = lotteryBrandingAssetColors;
        _this.lotteryBrandingAds = lotteryBrandingAds;
        _this.lotteryBrandingAssetText = lotteryBrandingAssetText;
        return _this;
    }
    LotteryBrandingDialog.prototype.getFilesToSave = function () {
        return [TemplateType.Lottery, TemplateType.Assets];
    };
    LotteryBrandingDialog.prototype.getBrandTemplateInternalName = function () { return this.item.brandTemplateInternalName; };
    LotteryBrandingDialog.prototype.getBrandThemeInternalName = function () { return this.item.brandThemeInternalName; };
    LotteryBrandingDialog.prototype.getBrandingSteps = function () {
        return [{
                title: this.i18N.tr('lottery'),
                step: StepEnum.LobbyBranding,
                show: true,
                view: "",
                children: [
                    {
                        title: this.i18N.tr("lottery-branding-text"),
                        vm: this.lotteryBrandingText,
                        show: true,
                        view: '../../app/admin/lottery/dialogs/branding-steps/lottery-branding-text.html'
                    },
                    {
                        title: this.i18N.tr("lottery-branding-images"),
                        vm: this.lotteryBrandingImages,
                        show: true,
                        view: '../../app/admin/lottery/dialogs/branding-steps/lottery-branding-images.html'
                    },
                    {
                        title: this.i18N.tr("lottery-branding-colors"),
                        vm: this.lotteryBrandingColors,
                        show: true,
                        view: '../../app/admin/lottery/dialogs/branding-steps/lottery-branding-colors.html'
                    }
                ]
            },
            {
                title: this.i18N.tr('assets'),
                step: StepEnum.AssetsBranding,
                show: true,
                view: "",
                children: [
                    {
                        title: this.i18N.tr("assets-branding-images"),
                        vm: this.lotteryBrandingAssets,
                        show: true,
                        view: '../../app/admin/lottery/dialogs/branding-steps/lottery-branding-assets.html'
                    },
                    {
                        title: this.i18N.tr("assets-branding-colors"),
                        vm: this.lotteryBrandingAssetColors,
                        show: true,
                        view: '../../app/admin/lottery/dialogs/branding-steps/lottery-branding-asset-colors.html'
                    },
                    {
                        title: this.i18N.tr("assets-branding-text"),
                        vm: this.lotteryBrandingAssetText,
                        show: true,
                        view: '../../app/admin/lottery/dialogs/branding-steps/lottery-branding-assets-text.html'
                    }
                ]
            }, {
                title: this.i18N.tr('ads'),
                step: StepEnum.LotteryAdsBranding,
                show: true,
                view: "",
                children: [
                    {
                        title: this.i18N.tr("lottery-branding-ads"),
                        vm: this.lotteryBrandingAds,
                        show: true,
                        view: '../../app/admin/lottery/dialogs/branding-steps/lottery-branding-ads.html'
                    }
                ]
            }];
    };
    LotteryBrandingDialog.prototype.getBrandDetails = function () {
        return {
            brandId: this.item.navigationInfo.brandId,
            brandName: this.item.navigationInfo.brandName,
            brandLanguages: this.item.navigationInfo.brandLanguages
        };
    };
    LotteryBrandingDialog.prototype.getImages = function () {
        return [this.lotteryBrandingImages.model, this.lotteryBrandingAssets.model, this.lotteryBrandingAds.model.image];
    };
    LotteryBrandingDialog.prototype.getRoute = function () {
        var key = LotteryKeyHelper.getKey(this.item.name);
        return "lottery/".concat(this.item.lotteryId, "/").concat(key);
    };
    LotteryBrandingDialog.prototype.includesNavigationInfo = function () {
        return true;
    };
    LotteryBrandingDialog.prototype.getRouteAdditionalData = function () {
        return "lotteryId=".concat(this.item.lotteryId);
    };
    LotteryBrandingDialog = __decorate([
        autoinject,
        __metadata("design:paramtypes", [Element, NotificationClientService, I18N, EventAggregator,
            LookupClientService, CacheClient, LotteryBrandingText, LotteryBrandingImages, LotteryBrandingAssets,
            LotteryBrandingColors, LotteryBrandingAssetColors, LotteryBrandingAds,
            TokenClient, DialogClientService, BrandClientService, AttachmentClientService,
            LotteryBrandingAssetsText, JsonLockClientService])
    ], LotteryBrandingDialog);
    return LotteryBrandingDialog;
}(BrandingPreviewBase));
export { LotteryBrandingDialog };
